import * as React from 'react'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaHeader,
  CredenzaTitle,
} from '~/client/components/ui/credenza'
import { SelectShareableListStep } from './SelectShareableListStep'
import { CreateShareableListStep } from './CreateShareableListStep'

type Step = 'select' | 'create'

type Props = {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  spaceId?: number
  initialStep?: Step
}

export function ShareableListDialog({ open = false, onOpenChange, spaceId, initialStep = 'select' }: Props) {
  const [step, setStep] = React.useState<Step>(initialStep)

  // Reset step when dialog opens
  React.useEffect(() => {
    if (open) setStep(initialStep)
  }, [open, initialStep])

  const title = step === 'select' ? 'Add to Collection' : 'Create New Collection'

  const handleDone = () => {
    onOpenChange?.(false)
  }

  return (
    <Credenza open={open} onOpenChange={onOpenChange}>
      <CredenzaContent className="sm:rounded-[8px] max-w-full md:max-w-[480px] max-h-[90dvh] min-h-0 flex flex-col">
        <CredenzaHeader>
          <CredenzaTitle className="text-[20px] font-semibold text-[#18003d]">
            {title}
          </CredenzaTitle>
        </CredenzaHeader>
        <CredenzaBody className="px-[20px] flex-1 min-h-0 overflow-y-auto">
          {step === 'select' ? (
            <SelectShareableListStep
              spaceId={spaceId}
              onCreateNew={() => setStep('create')}
              onDone={handleDone}
            />
          ) : (
            <CreateShareableListStep
              spaceId={spaceId}
              onBack={initialStep === 'create' ? undefined : () => setStep('select')}
              onCancel={initialStep === 'create' ? handleDone : undefined}
              onDone={handleDone}
            />
          )}
        </CredenzaBody>
      </CredenzaContent>
    </Credenza>
  )
}
